import React from 'react';
import PropTypes from 'prop-types';
import { StripeSetupProvider } from 'Context/StripeSetupContext';
import fr from 'facet-rest';
import AddPaymentMethodProfileSubpageContent
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/AddPaymentMethodProfileSubpage/AddPaymentMethodProfileSubpageContent';

const AddPaymentMethodProfileSubpage = ({
  className,
  resource,
}) => {
  return (
    <StripeSetupProvider tokenSubmitLink={resource.link('self')}>
      <AddPaymentMethodProfileSubpageContent className={className} resource={resource} />
    </StripeSetupProvider>
  );
};

AddPaymentMethodProfileSubpage.defaultProps = {
  className: '',
};

AddPaymentMethodProfileSubpage.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AddPaymentMethodProfileSubpage;
